import vanThreeSlide from "./index.vue";

/* istanbul ignore next */
vanThreeSlide.install = function(Vue) {
  Vue.component(vanThreeSlide.name, vanThreeSlide);
};

export default vanThreeSlide;
